import React, { Component } from 'react';

class Board extends Component {
	render() {
		const { title, departments } = this.props.data;
		return (
			<section id="board" className="container-fluid">
				<div className="container container-fluid">
					<div className="row between-md">
						<div className="col-xs-12 col-md-12 center-md center-xs">
							<h3>{title}</h3>
						</div>
						{departments.map((department, index) => (
							<div
								key={index}
								className="col-xs-12 col-md-4 center-md center-xs"
							>
								<div className="department">
									<h5>{department.value.department_name}</h5>
									{department.value.roles.map((role, index) => (
										<div key={index} className="role start-md start-xs">
											<h6>{role.value.role_name}</h6>
											{role.value.people.map((person, index) => (
												<p key={index}>{person.value}</p>
											))}
										</div>
									))}
								</div>
							</div>
						))}
					</div>
				</div>
			</section>
		);
	}
}

export default Board;
